import type { WizardStepRoute } from '../../index';
import { PrizesStep } from './PrizesStep';
import { SponsorsStep } from './SponsorsStep';

export const catalogWizardSteps: WizardStepRoute[] = [
  { step: 'prizes', element: <PrizesStep /> },
  { step: 'sponsors', element: <SponsorsStep /> },
];
